import React from 'react';
import { SimpleGrid, Box, Stat, StatLabel, StatNumber, StatHelpText, Heading } from '@chakra-ui/react';

export const Dashboard = ({ stats }) => {
  return (
    <Box>
      <Heading size="md" mb={6}>Overview</Heading>

      <SimpleGrid columns={{ base: 1, md: 2, lg: 5 }} spacing={6}>
        <Box bg="white" p={6} borderRadius="lg" boxShadow="sm">
          <Stat>
            <StatLabel color="gray.500">Total Users</StatLabel>
            <StatNumber color="brand.500">{stats.users.total}</StatNumber>
            <StatHelpText>{stats.users.active} active</StatHelpText>
          </Stat>
        </Box>

        <Box bg="white" p={6} borderRadius="lg" boxShadow="sm">
          <Stat>
            <StatLabel color="gray.500">Admin Users</StatLabel>
            <StatNumber color="blue.500">{stats.users.admins}</StatNumber>
            <StatHelpText>super admins</StatHelpText>
          </Stat>
        </Box>

        <Box bg="white" p={6} borderRadius="lg" boxShadow="sm">
          <Stat>
            <StatLabel color="gray.500">Managers</StatLabel>
            <StatNumber color="purple.500">{stats.users.managers}</StatNumber>
            <StatHelpText>manager accounts</StatHelpText>
          </Stat>
        </Box>

        <Box bg="white" p={6} borderRadius="lg" boxShadow="sm">
          <Stat>
            <StatLabel color="gray.500">Total Assessments</StatLabel>
            <StatNumber color="green.500">{stats.assessments.total}</StatNumber>
            <StatHelpText>{stats.assessments.newThisWeek} this week</StatHelpText>
          </Stat>
        </Box>

        <Box bg="white" p={6} borderRadius="lg" boxShadow="sm">
          <Stat>
            <StatLabel color="gray.500">New Users (Week)</StatLabel>
            <StatNumber color="orange.500">{stats.users.newThisWeek}</StatNumber>
            <StatHelpText>registered this week</StatHelpText>
          </Stat>
        </Box>
      </SimpleGrid>
    </Box>
  );
};

export default Dashboard;
